<sbw-layout
    [backButtonVisible]="true"
    [type]="'Amendment'"
    [form]="amendmentsForm"
    [continueButtonDisabled]="!this.isAmendmentCompatible || !this.vehiclesChanged"
    (continueEvent)="continue()"
    (backEvent)="navigateBack()"
    >
    <div *ngIf="vehicleWire" class="sbw_pagebox">
        <div class="row uncollapse vehicle-container">
            <h1>{{'VEHICLE_AMENDMENT_TITLE' | resource}}</h1>
            <div class="sbw_legend" [innerHTML]="'VEHICLE_AMENDMENT_TEASER' | resource"></div>
            <div class="row">
                <div class="column small-12 gutter">
                    <sbw-validation-summary [errorList]="errors"></sbw-validation-summary>

                    <div *ngIf="vehicleWire.isAmendmentCompatible" class="row">
                            <h2 class="column">{{'VEHICLE_TYPE' | resource}}</h2>
                            <sbw-vehicles-selector [formVehicleSelector]="selector" [vehicles]="vehicles" [trailers]="trailers" [supportMultiple]="vehicleSupportMultiple"></sbw-vehicles-selector>
                    </div>
                    <div class="row" *ngIf="vehicleWire.isAmendmentCompatible">
                            <h2 class="column">{{'PASSENGERS_VEHICLE_DETAILS' | resource}}</h2>
                            <sbw-vehicles-details-rows [mode]="'Amendment'" [model]="inputVehiclesDetailsRows" [countControl]="amendmentsForm.get('selector.count')"
                                [selectedVehicleControl]="amendmentsForm.get('selector.vehicle')" [selectedTrailerControl]="amendmentsForm.get('selector.trailer')"></sbw-vehicles-details-rows>
                    </div>
                </div>
            </div>
        </div>
    </div>
</sbw-layout>